<template>
  <PreviewPane :loaded="!loading" :title="''">

    <template v-slot:header>
      <v-toolbar dense flat class="minitoolbar">
        <template v-if="loading">
          <v-skeleton-loader type="heading" class="mx-2" style="width: 200px;" />
        </template>
        <template v-else>
          <v-btn v-if="closePreview !== undefined" icon class="ml-n3 mr-2" small @click="closePreview()">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <h4 class="my-auto">
            <span>Edit detail</span>
          </h4>

          <v-spacer />

          <v-btn class="mr-2 px-2" small :color="anyLoading ? 'disabled' : 'error'" outlined :disabled="anyLoading"
            :dark="!anyLoading" :loading="deleteLoading" @click="handleDelete(editObject.Id)">
            <v-icon size="14" class="mr-1">$delete</v-icon>
            {{ $t("servicesystem.common_objects.commonterms.delete") }}
          </v-btn>

          <v-btn small class="px-2 mr-n1" :color="saveable ? 'primary' : 'disabled'" :disabled="!saveable"
            :dark="saveable" :loading="saveLoading" @click="handleSave()">
            <v-icon size="14" class="mr-1">$save</v-icon>
            {{ $t('servicesystem.common_objects.commonterms.save') }}
          </v-btn>

        </template>
      </v-toolbar>
    </template>

    <template v-slot:content>
      <template v-if="error">
        <v-alert type="error" class="ma-3">
          Error loading detail
        </v-alert>
      </template>

      <template v-else-if="editObject">
        <div :key="fetchkey + '-' + editObject.Id" style="background-color: white;">
          <v-card v-if="!isParentDetail && parentDetail" class="rounded-0" @click="openDetail(parentDetail.Id)">
            <v-list-item class="px-3" style="background-color: #f9f8f8;">
              <v-list-item-icon class="my-auto mr-3">
                <v-icon size="20">
                  mdi-folder-open
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content class="py-0">
                <v-list-item-title class="d-flex align-center">
                  <span style="padding-top: 2px;">Parent detail:</span>
                  <v-btn text color="primary" class="px-2" style="text-transform: none; height: 24px;"
                    @click="openDetail(parentDetail.Id)">
                    {{ getDetailText(parentDetail) }}
                  </v-btn>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon class="my-auto ml-3">
                <v-icon size="20">
                  mdi-chevron-right
                </v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-divider></v-divider>
          </v-card>


          <v-form v-model="valid">
            <ContractDetailTypeControl :detail="editObject" :isParentDetail="isParentDetail" :contract="contract">
            </ContractDetailTypeControl>

            <ContractDetailPriceControl v-model="editObject" class="py-3">
            </ContractDetailPriceControl>

            <v-list v-if="isParentDetail" class="py-3 px-3">
              <b>Contract</b>
              <v-row no-gutters class="my-2">
                <v-col cols="6" class="pr-3">
                  <QDateField3 v-model="editObject.ContractStart" label="Start date" :min="null" :max="null"
                    externaledit>
                  </QDateField3>
                </v-col>
                <v-col cols="6">
                  <QDateField3 v-model="editObject.ContractEnd" label="End date" :min="null" :max="null" externaledit>
                  </QDateField3>
                </v-col>
              </v-row>
              <v-row no-gutters class="my-2" align="end">
                <v-col cols="6" class="pr-3">
                  <QDateField3 v-model="editObject.ContractTerminatedDate" label="Terminate from date" :min="null"
                    :max="null" externaledit>
                  </QDateField3>
                </v-col>
                <!--<v-col>
                  <v-btn small style="text-transform: none;">
                    Deactivate
                  </v-btn>
                </v-col>-->
              </v-row>

            </v-list>

            <v-list v-if="isParentDetail" class="py-0 px-3 pt-3 pb-2">
              <b>Invoice</b>
              <v-row no-gutters>
                <v-col cols="6" class="pr-3">
                  <QTextField v-model="editObject.InvoiceLengthMonths" label="Invoice period" externaledit suffix="x"
                    :rules="[floatRule]">
                  </QTextField>
                </v-col>
              </v-row>
              <v-row no-gutters class="my-3">
                <v-col cols="6" class="pr-3">
                  <QDateField3 v-model="editObject.NextInvoiceStartDate" label="Start date" :min="null" :max="null"
                    externaledit>
                  </QDateField3>
                </v-col>
                <v-col cols="6">
                  <QDateField3 v-model="editObject.NextInvoiceEndDate" label="End date" :min="null" :max="null"
                    externaledit>
                  </QDateField3>
                </v-col>
              </v-row>

              <CustomerSelect v-model="editObject.InvoiceCustomerId" label="Invoice customer"
                :placeholder="'Alternative invoice customer for this detail'" externaledit clearable hideIcon>
              </CustomerSelect>
            </v-list>
            <v-row no-gutters class="px-3" style="background-color: var(--v-invoiceCommentBackground-base);">
              <QTextArea v-model="editObject.InvoiceComment" label="Invoice comment" externaledit class="mb-3 mt-2"
                :backgroundcolor="'var(--v-invoiceCommentBackground-base)'">
              </QTextArea>
            </v-row>

          </v-form>

          <template v-if="isParentDetail && allowNestedContractDetails">
            <v-divider></v-divider>
            <div class="px-3 pt-2 pb-4" style="background-color: #f9f8f8;">
              <v-row no-gutters align="center" class="mb-2">
                <v-col cols="auto" class="pr-3">
                  <v-icon size="20">
                    mdi-folder-open
                  </v-icon>
                </v-col>
                <v-col>
                  <b>Nested details</b>
                </v-col>
                <v-col cols="auto">
                  <v-btn v-if="isParentDetail" class="ml-2 px-2" small dark color="quaternary"
                    @click="handleAddChild()">
                    <v-icon size="18" class="mr-1">mdi-plus</v-icon>
                    New
                  </v-btn>
                </v-col>
              </v-row>

              <template v-if="editObject.SubContractDetails && editObject.SubContractDetails[0]">
                <v-row no-gutters v-for="(child, index) in editObject.SubContractDetails" :key="child.Id">
                  <v-col cols="0" style="max-width: calc(100% - 44px);">
                    <v-list-item class="px-0" dense @click="openDetail(child.Id)">
                      <v-list-item-icon class="my-auto mr-2">
                        <v-icon size="20">
                          mdi-circle-medium
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content class="py-0">
                        <v-list-item-title class="d-flex align-center primary--text">
                          {{ getDetailText(child) }}
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-icon class="my-auto ml-3">
                        <v-icon size="20">
                          mdi-chevron-right
                        </v-icon>
                      </v-list-item-icon>
                    </v-list-item>
                  </v-col>
                  <SpecialDeleteButton :deleteFunc="() => handleDeleteChild(child.Id)" :roundTop="index == 0"
                    :roundBottom="index == (editObject.SubContractDetails.length - 1)">
                  </SpecialDeleteButton>
                </v-row>

              </template>
              <template v-else>
                <p class="mt-3">No nested details</p>
              </template>
            </div>
          </template>
        </div>
      </template>
    </template>
  </PreviewPane>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import PreviewPane from "@/views/layouts/PreviewPane.vue";
import CustomerSelect from "@/components/Inputs/EntityDropdowns/CustomerSelect2.vue";
import ContractDetailPriceControl from "./ContractDetailPriceControl.vue";
import QDateField3 from "@/components/Inputs/QDateField3.vue";
import ContractMixin from "@/helpers/Mixins/ContractMixin";
import SpecialDeleteButton from "./SpecialDeleteButton.vue";
import ContractDetailTypeControl from "./ContractDetailTypeControl.vue";

export default {
  name: "EditContractDetailPane",
  props: {
    id: [String, Number],
    contract: Object,
    closePreview: Function,
  },
  components: {
    PreviewPane,
    CustomerSelect,
    ContractDetailPriceControl,
    SpecialDeleteButton,
    QDateField3,
    ContractDetailTypeControl,
  },
  mixins: [clientAPI, ContractMixin],

  data() {
    return {
      fetchkey: 1,
      loading: true,
      saveLoading: false,
      deleteLoading: false,
      detail: null,
      editObject: null,
      copyObject: null,
      valid: true,
      error: null,
      parentDetail: null,
    };
  },

  mounted() {
    this.get();
  },

  methods: {
    get() {
      this.loading = true;
      this.error = null;
      this.getContractDetailById(this.id)
        .then((response) => {
          this.SetDetails(response);
        })
        .catch((e) => {
          console.error(e);
          this.detail = null;
          this.editObject = null;
          this.copyObject = null;
          this.error = e;
        })
        .finally(() => {
          this.fetchkey++;
          this.loading = false;
        });
    },

    SetDetails(detail) {
      if (detail) {
        // Deep clone to avoid shared references; needed for IsChanged comparison
        const deep = JSON.parse(JSON.stringify(detail));
        this.editObject = deep;
        this.copyObject = JSON.parse(JSON.stringify(detail));
        if (this.editObject && this.editObject.ParentDetailId) {
          this.loadParentDetail(this.editObject.ParentDetailId);
        } else {
          this.parentDetail = null;
        }
      } else {
        this.editObject = null;
        this.copyObject = null;
        this.parentDetail = null;
      }
    },

    async handleSave() {
      this.saveLoading = true;
      const dto = Object.assign({}, this.editObject);
      dto.ContractArticleId = this.editObject.ContractArticle?.Id;
      // Strip nested navigation objects/collections; backend maps by FK ids
      delete dto.Article;
      delete dto.ContractArticle;
      delete dto.PriceModel;
      delete dto.Customer;
      delete dto.Machine;
      // Keep prices and consumptions; only remove payment plans (handled separately server-side)
      delete dto.ContractPaymentPlans;
      delete dto.SubContractDetails;
      await this.changeContractDetail(dto).then(result => {
        this.SetDetails(result);
        //this.closePreview();
        this.fetchkey++;
        this.saveLoading = false;
        this.$emit('OnUpdate', result);
      })
    },

    async handleDeleteChild(childId) {
      if (!await this.$store.dispatch('ConfirmDialog/Show')) {
        return;
      }
      if (!this.editObject || !Array.isArray(this.editObject.SubContractDetails)) return;
      const list = this.editObject.SubContractDetails;
      const idx = list.findIndex(c => c.Id === childId);
      if (idx === -1) return;
      const child = list[idx];
      this.$set(child, 'removeLoading', true);
      await this.deleteContractDetail(childId)
        .then(() => {
          // Remove locally from parent children list
          this.editObject.SubContractDetails = list.filter(c => c.Id !== childId);
          // Notify parent view to remove from table/tree
          this.$emit('DetailDeleted', { id: childId });
        })
        .catch(e => {
          console.error(e);
          this.$set(child, 'removeLoading', false);
        });
    },

    async handleDelete(id) {
      if (!await this.$store.dispatch('ConfirmDialog/Show')) {
        return;
      }
      this.deleteLoading = true;
      await this.deleteContractDetail(id)
        .then(() => {
          // Notify parent view to remove from table/tree
          this.$emit('DetailDeleted', { id: id, parentId: this.editObject?.ParentDetailId ?? null });
          this.closePreview();
        }).catch(e => {
          console.error(e);
          this.deleteLoading = false;
        })
    },

    handleAddChild() {
      if (this.editObject && this.isParentDetail) {
        this.$emit('AddChildRequested', this.editObject);
      }
    },

    async loadParentDetail(parentId) {
      try {
        const parent = await this.getContractDetailById(parentId);
        this.parentDetail = parent || null;
      } catch (e) {
        console.error('loadParentDetail', e);
        this.parentDetail = null;
      }
    },

    openDetail(id) {
      if (!id) return;
      this.$router.push({ query: { ...this.$route.query, detailId: id } });
    },

    insertChildDetail(child) {
      if (!child || !this.editObject) {
        return;
      }
      const parentId = this.editObject.Id;
      if (!parentId || child.ParentDetailId !== parentId) {
        return;
      }
      if (!Array.isArray(this.editObject.SubContractDetails)) {
        this.$set(this.editObject, 'SubContractDetails', []);
      }
      this.editObject.SubContractDetails.unshift(child);
    },
  },

  computed: {
    allowNestedContractDetails() {
      return this.$store.state.GlobalSettings.AllowNestedContractDetails;
    },
    IsChanged() {
      if (this.editObject && this.copyObject) {
        return !this.SameValue(this.editObject, this.copyObject);
      } else {
        return false;
      }
    },

    anyLoading() {
      return this.loading || this.deleteLoading || this.saveLoading;
    },

    saveable() {
      return this.IsChanged && this.valid && !this.anyLoading;
    },

    isParentDetail() {
      return !this.editObject.ParentDetailId;
    },
  },

  watch: {
    id: function () {
      this.get();
    },
    "$route.query.timestamp"() {
      this.get();
    },
  },
};
</script>

<style>
.rounded-bottom-subtle {
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.rounded-top-subtle {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
</style>